export const signupDiscountSuppliers = ["topdawg", "beautyjoint", "savoyactive", "fragrancenet"];
